import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStoreinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M57 31L57 55C57 56.1045695 56.1045695 57 55 57L9 57C7.8954305 57 7 56.1045695 7 55L7 31M9 20L55 20"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				stroke: "#000",
				strokeWidth: 2,
				points: "39 38 39 56 25 56 25 38",
				transform: "rotate(180 32 47)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M58,26 C58,29.7287 55.9787,32 52.25,32 C48.5213,32 45.5,29.7287 45.5,26 C45.5,29.7287 42.4787,32 38.75,32 C35.0213,32 32,29.7287 32,26 C32,29.7287 28.9787,32 25.25,32 C21.5213,32 18.5,29.7287 18.5,26 C18.5,29.7287 15.4787,32 11.75,32 C8.0213,32 6,29.7287 6,26 L9.66568862,8.58797904 C9.86052807,7.66249168 10.6770138,7 11.6227882,7 L52.3772118,7 C53.3229862,7 54.1394719,7.66249168 54.3343114,8.58797904 L58,26 Z"
			})
		]
	})
});
export default SvgStoreinline;
